<template>
    <div>
        <div class="py-10 mb-10">
            <div class="col-sm-6 col-xl-4">
                <button
                    @click.prevent="showModal"
                    type="button"
                    class="btn mybtn btn-rounded  min-width-125"
                    data-toggle="click-ripple"
                    style="overflow: hidden; position: relative; z-index: 1;"
                >
                    <i class="si si-credit-loan"></i>
                    Loan Request
                </button>
            </div>
        </div>

        <div class="row">
            <div class="block-content">
                <div class="col-sm-12 table-responsive">
                    <table class="table table-striped table-vcenter">
                        <thead>
                            <tr role="row">
                                <th class="text-center" tabindex="0">
                                    #
                                </th>
                                <th class="text-capitalize">
                                    Amount
                                </th>
                                <th class="text-capitalize">
                                    Description
                                </th>

                                <th class="text-capitalize">
                                    Application Date
                                </th>
                                <th class="text-capitalize">
                                    Payment Date
                                </th>
                                <th class="text-capitalize">
                                    status
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                role="row"
                                class="odd"
                                v-for="(loan, index) in loans"
                            >
                                <td class="text-center sorting_1">
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ loan.amount }}
                                </td>
                                <td>
                                    {{ loan.description }}
                                </td>
                                <td>
                                    {{ loan.when }}
                                </td>
                                <td>
                                    {{ loan.at }}
                                </td>
                                <td>
                                    <span
                                        class="text-warning"
                                        v-if="loan.status == 0"
                                        >Pending</span
                                    >
                                    <span class="text-success" v-else
                                        >Success</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- loan request modal -->
        <div
            class="modal fade"
            id="modal-invest"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-popin"
            style="display: none;"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-popin"
                role="document"
            >
                <div class="modal-content">
                    <div class="block block-transparent mb-0">
                        <div class="block-header">
                            <h3 class="block-title">
                                New loan request
                            </h3>
                            <div class="block-options">
                                <button
                                    type="button"
                                    class="btn-block-option"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i class="si si-close"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content">
                            <form @submit.prevent="requestLoan">
                                <div class="modal-body">
                                    <div class="loan">
                                        <div class="loan-body">
                                            <div class="form-group row">
                                                <div class="col-lg-12">
                                                    <label for="account"
                                                        >Loan Amount</label
                                                    >

                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="amount"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label
                                                    class="col-12"
                                                    for="example-daterange1"
                                                    >Repayment Date</label
                                                >
                                                <div class="col-lg-12">
                                                    <input
                                                        v-model="expiry"
                                                        type="date"
                                                        class="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col-lg-12">
                                                    <label for="account"
                                                        >Description</label
                                                    >
                                                    <textarea
                                                        v-model="description"
                                                        class="form-control"
                                                        cols="30"
                                                        rows="10"
                                                    ></textarea>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div
                                                    v-if="processing"
                                                    class="col-6 col-md-3"
                                                >
                                                    <i
                                                        class="fa fa-2x fa-cog fa-spin text-primary"
                                                    ></i>
                                                </div>
                                                <div class="col-md-9" v-else>
                                                    <button
                                                        type="submit"
                                                        class="btn btn-danger mb-2"
                                                    >
                                                        Request Loan
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end of loan request  modal -->
    </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../repository/RepositoryFactory";
const AR = Repo.get("users");
export default {
    data() {
        return {
            loans: [],
            amount: 0,
            expiry: "",
            description: "Reason for loan request",
            processing: false
        };
    },
    methods: {
        showModal() {
            $("#modal-invest").modal("show");
        },
        async requestLoan() {
            if (!this.amount || !this.description || !this.to || this.from) {
                toast.fire({
                    type: "error",
                    title: "Ensure all fields are filled"
                });
            }
            this.processing = true;
            let data = {
                amount: this.amount,
                description: this.description,
                expiry: this.expiry
            };
            try {
                await AR.userLoanRequest(data);
                $("#modal-invest").modal("hide");
                this.processing = false;
                this.loadLoans();
                toast.fire({
                    type: "success",
                    title: "Loan request has been sent successfully"
                });
            } catch (error) {
                this.processing = false;

                console.log(error);
            }
        },
        async loadLoans() {
            try {
                let res = await AR.userFetchLoans();
                this.loans = res.data;
            } catch (error) {
                console.log(error);
            }
        }
    },
    created() {
        this.loadLoans();
    }
};
</script>
